<template>
    <div :style="cssProps">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">通知揽件</h1>
                    <p class="text-white pb-3 px-3">เลือกจำนวนเครดิต หรือ ระบุจำนวนเครดิต
                        เพื่อทำการเติมเข้ากระเป๋าของคุณ
                    </p>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow py-5">
                        <div class="col-lg-12">
                            <div>
                                <h1>通知揽件</h1>
                                <noticeExpressList></noticeExpressList>
                                <h1 class="mt-3">揽件历史</h1>
                                <collectionHistory></collectionHistory>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {hexToRgbA} from "@/plugins/hexColor";
import noticeExpressList from "@/views/newPages/Notification/noticeExpressList.vue";
import collectionHistory from "@/views/newPages/Notification/collectionHistory.vue";

export default {
    name: "",
    components: {
        noticeExpressList,
        collectionHistory
    },
    data() {
        return {
            busy: false,
        }
    },
    created() {

    },
    mounted() {
    },
    methods: {

    },
    computed: {
        cssProps() {
            return {
                '--bg-hover-color': hexToRgbA('#11cdef', 0.7),
                '--bg-color': '#11cdef',
            }
        }
    }
};
</script>
<style scoped>

</style>
